/**
 * Arming the one-shot feedback prompt (T15-M3).
 *
 * The three trigger moments all happen on a page that is about to disappear:
 * posting a job and sending a quote both `navigate(..., {replace: true})` on
 * success, and submitting a review closes the modal it was asked from. A modal
 * mounted by any of those pages would unmount before it could be seen.
 *
 * So the host is mounted once at the root — the same reason the tab bar and the
 * Dany FAB are — and the pages only say "now would be a good moment". This
 * module is that sentence, and nothing more.
 *
 * In memory rather than in `sessionStorage`, unlike `armPushInvite`: every
 * trigger is a client-side navigation with the host alive across it, and a
 * reload in between is a person who moved on. The gate that makes this
 * ONE-SHOT is `user_profiles.feedback_prompt_done` on the server, not anything
 * here — a flag in a tab would offer the prompt again on the next device.
 */

let armed = false;
const listeners = new Set();

/** "A real thing just succeeded." The host decides whether to act on it. */
export function armFeedbackPrompt() {
  armed = true;
  listeners.forEach((fn) => fn());
}

export function isArmed() {
  return armed;
}

/** Spent: the prompt was shown, or the host decided it never will be. */
export function disarmFeedbackPrompt() {
  armed = false;
}

export function subscribeFeedbackPrompt(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
